import { VOUCHER_LOGS } from 'actions/voucher';

const initialState = {
  isLoading: false,
  voucherLogsDetail: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const voucherLogsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case VOUCHER_LOGS.REQUEST: {
      return { ...state, isLoading: true };
    }

    case VOUCHER_LOGS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        voucherLogsDetail: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case VOUCHER_LOGS.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default voucherLogsReducer;
